import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '@/components/ui/switch';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/redux/store';
import { useAuth } from '@/context/Auth';
import { Label } from '@/components/ui/label';
import { setDarkTheme } from '@/redux/userSlice';

const DarkThemeToggle: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { updateUserSettings } = useAuth();
  const { darkTheme } = useSelector((state: RootState) => state.user.settings);

  const toggleDarkTheme = async () => {
    const newDarkTheme = !darkTheme;

    // First update Redux (which will also update localStorage)
    dispatch(setDarkTheme(newDarkTheme));

    // Then update Supabase if user is logged in
    await updateUserSettings({
      dark_theme: newDarkTheme,
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Label className="text-sm">
        {t('profile.display_preferences.dark_theme.title.translation')}
      </Label>
      <Switch checked={darkTheme} onCheckedChange={toggleDarkTheme} />
    </div>
  );
};

export default DarkThemeToggle;
